var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75227 0.797266C8.80373 0.0333338 10.2275 0.0333343 11.279 0.797266L17.2628 5.14479C18.3143 5.90872 18.7543 7.26282 18.3526 8.49889L16.067 15.5333C15.6654 16.7694 14.5135 17.6063 13.2139 17.6063H5.8174C4.51772 17.6063 3.36585 16.7694 2.96423 15.5333L0.678602 8.49889C0.276979 7.26282 0.716954 5.90872 1.76842 5.14479L7.75227 0.797266Z",
    fill: "#9F7AEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.e853b2685bfbd915ddf8d686f625ccfe.svg";
export { ForwardRef as ReactComponent };